module.exports = __webpack_public_path__ + "static/hyperv_7.6f65180e.jpg";